"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
/**
 * Get if the company is a capital deposit
 */
const getIsCapitalDeposit = async ({ companyProfileId, photon, }) => {
    const { data: [capitalDeposit], } = await photon.capitalDeposits.get('', {
        params: { companyProfileId },
    });
    return (!!capitalDeposit &&
        capitalDeposit.status !== constants_1.CAPITAL_DEPOSIT_STATUS.OPTED_OUT);
};
exports.default = getIsCapitalDeposit;
